import React, { useEffect, useState } from "react";
import styles from "./style.module.css";
import SearchIcon from "../../../assets/icons/search.svg";
import FilterIcon from "../../../assets/icons/icon-filter.svg";
import Sidebar from "../../partials/Sidebar";
import Header from "../../partials/Header";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import { Button, Popconfirm, Tooltip, message, Modal, Input } from "antd";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { motion } from "framer-motion";
import HashLoader from "react-spinners/ClipLoader";
import { notification } from "antd";
import InfoIcon from "../../../assets/inform.svg";
import DeleteIcon from "../../../assets/delete.svg";
import EditIcon from "../../../assets/edit.svg";
import LockerIcon from "../../../assets/opnlocker.svg";
import ResendEmailIcon from "../../../assets/resend_email.svg";
const Pickups = () => {
  const url = process.env.REACT_APP_APP_BACK_URL;
  const react_base_url = process.env.REACT_APP_BASE_URL;
  const [data, setData] = useState([]);
  const isAuthenticated = useSelector((state) => state.user);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 10;
  const [isNotFound, setIsNotFound] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisplay, setIsDisplay] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [sizes, setSizes] = useState([]);
  const [itemLoadingStates, setItemLoadingStates] = useState({});
  const [doorLoadingStates, setDoorLoadingStates] = useState({});
  const [resendModalOpen, setResendModalOpen] = useState(false);
  const [resendTarget, setResendTarget] = useState(null);
  const [resendEmail, setResendEmail] = useState("");
  const [resendLoading, setResendLoading] = useState(false);
  const [credentials, setCredentials] = useState({ status: "all", number: "" });
  const handleInput = (e) => {
    setCurrentPage(1);
    setCredentials((prevCredentials) => {
      const updatedCredentials = {
        ...prevCredentials,
        [e.target.name]: e.target.value,
      };
      fetchData(updatedCredentials);
      return updatedCredentials;
    });
  };
  useEffect(() => {
    fetchData(credentials);
  }, [currentPage]);
  const fetchData = async (fetchCredentials) => {
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      headers.append("auth-token", localStorage.getItem("token"));
      setIsLoading(true);
      setIsDisplay(false);
      setIsNotFound(false);
      const response = await fetch(
        `${url}/api/pickups/list?page=${currentPage}&limit=${itemsPerPage}&number=${fetchCredentials.number}&status=${fetchCredentials.status}`,
        {
          mode: "cors",
          method: "GET",
          headers: headers,
        }
      );
      setIsLoading(false);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const json = await response.json();
      if (json.pickups.length > 0) {
        setIsDisplay(true);
        setData(json.pickups);
      } else {
        setIsNotFound(true);
      }
      setTotalPages(json.totalPages);
    } catch (error) {
      console.error(error);
    }
  };
  const handleResetBtn = () => {
    const updatedCredentials = {
      number: "",
      status: "all",
    };
    // Update state and then call fetchData
    setCredentials(updatedCredentials);
    setCurrentPage(1);
    // Call fetchData with the updated credentials
    fetchData(updatedCredentials);
  };
  const handleDelete = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        reverseButtons: true,
      });
      if (result.isConfirmed) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Access-Control-Allow-Origin", "*");
        headers.append("Access-Control-Allow-Credentials", "true");
        const response = await fetch(`${url}/api/pickups/delete/${id}`, {
          mode: "cors",
          method: "DELETE",
          headers: headers,
        });
        if (response.ok) {
          const json = await response.json();
          if (json.success) {
            fetchData(credentials);
            Swal.fire("Deleted!", "Locker deleted successfully!", "success");
          } else {
            Swal.fire("Error", json.error, "error");
          }
        } else {
          Swal.fire(
            "Error",
            "An error occurred while deleting the record.",
            "error"
          );
        }
      }
    } catch (error) {
      console.log("Error deleting record:", error);
      Swal.fire(
        "Error",
        "An error occurred while deleting the record.",
        "error"
      );
    }
  };
  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1); // react-paginate uses zero-based indexing
  };
  const formattedDate = (date) => {
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    };
    return new Date(date).toLocaleString("en-US", options);
  };
  const HandleOpenLocker = async (id, relay) => {
    let state = "2";
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Access-Control-Allow-Origin", "*");
    headers.append("Access-Control-Allow-Credentials", "true");
    setItemLoadingStates((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: true, // Set loading to true for the clicked item
    }));
    const response = await fetch(`${url}/api/lockers/relay/state/update`, {
      mode: "cors",
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        id: id,
        state: state,
      }),
    });
    setItemLoadingStates((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: false, // Set loading to true for the clicked item
    }));
    const json = await response.json();
    console.log(json);
    if (json.success) {
      notification.success({
        message: "Success",
        description: json.message,
        duration: 3,
      });
    } else {
      setItemLoadingStates((prevLoadingStates) => ({
        ...prevLoadingStates,
        [id]: false, // Set loading to true for the clicked item
      }));
      notification.error({
        message: "Failed",
        description: json.error,
        duration: 3,
      });
    }
  };
  const HandleOpenDoor = async (id) => {
    let state = "2";
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Access-Control-Allow-Origin", "*");
    headers.append("Access-Control-Allow-Credentials", "true");
    setDoorLoadingStates((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: true, // Set loading to true for the clicked item
    }));
    const response = await fetch(`${url}/api/lockers/open`, {
      mode: "cors",
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        id: id,
        state: state,
      }),
    });
    setDoorLoadingStates((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: false, // Set loading to true for the clicked item
    }));
    const json = await response.json();
    if (json.success) {
      notification.success({
        message: "Success",
        description: json.message,
        duration: 3,
      });
    } else {
      setDoorLoadingStates((prevLoadingStates) => ({
        ...prevLoadingStates,
        [id]: false, // Set loading to true for the clicked item
      }));
      notification.error({
        message: "Failed",
        description: json.error,
        duration: 3,
      });
    }
  };
  function toggleFilterSection() {
    setIsFilterVisible(!isFilterVisible);
  }
  const openResendModal = (item) => {
    setResendTarget(item);
    setResendEmail(item.customer_email || "");
    setResendModalOpen(true);
  };
  const closeResendModal = () => {
    setResendModalOpen(false);
    setResendTarget(null);
    setResendEmail("");
  };
  const handleResendEmail = async () => {
    if (!resendTarget) return;
    const emailTo = resendEmail.trim();
    if (!emailTo) {
      notification.error({
        message: "Failed",
        description: "Please enter a customer email",
        duration: 3,
      });
      return;
    }
    try {
      setResendLoading(true);
      const response = await fetch(`${url}/api/pickups/resend-email`, {
        mode: "cors",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Credentials": "true",
          "auth-token": localStorage.getItem("token"),
        },
        body: JSON.stringify({
          pickup_id: resendTarget._id,
          base_url: react_base_url,
          customer_email: emailTo,
        }),
      });
      const json = await response.json();
      if (json.success) {
        notification.success({
          message: "Success",
          description: json.message || "Pickup email resent successfully",
          duration: 3,
        });
        fetchData(credentials);
        closeResendModal();
      } else {
        notification.error({
          message: "Failed",
          description: json.error || "Could not resend email",
          duration: 3,
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: error.message,
        duration: 3,
      });
    } finally {
      setResendLoading(false);
    }
  };
  const [isActive, setIsActive] = useState(false);
  const toggleActive = () => {
    setIsActive(!isActive);
  };
  // Define the CSS classes based on the isActive state
  const divClassName = isActive ? "sidebar active" : "sidebar";
  return (
    <div className="general-dashboard">
      <div className="container-fluid">
        <div className="dashboard-top-row">
          <div className="row">
            <div className="col-lg-4 my-auto">
              <div className="user-wrap">
                <h3>Pickups</h3>
                <p>List of all the pickups registered</p>
              </div>
            </div>
            <div className="col-lg-6 text-end">
              <div className="filter-right-sec">
                <div className="filter-wrap">
                  <div className="filter-box" onClick={toggleFilterSection}>
                    <img src={FilterIcon} alt="" />
                  </div>
                </div>
                {isAuthenticated?.role !== "superAdmin" && (
                  <Link to="/pickup/add" className="btn btn-prim w-auto">
                    Book a Pickup
                  </Link>
                )}
              </div>
            </div>
          </div>
          {isFilterVisible && (
            <>
              <motion.div
                className={`row mt-5 filter-section`}
                initial={{ opacity: 0 }} // Initial state (hidden)
                animate={{ opacity: isFilterVisible ? 1 : 0 }} // Animate opacity based on isFilterVisible
                transition={{ duration: 1.2, delay: 0.1 }}
              >
                <div className="col-12">
                  <div className="filter-right-sec filter-wrap-chat">
                    <div className="search-wrap">
                      <input
                        type="search"
                        placeholder="order number"
                        name="number"
                        value={credentials.number}
                        onChange={handleInput}
                      />
                      <div className="search-box">
                        <img src={SearchIcon} alt="" />
                      </div>
                    </div>
                    <div className="filter-select d-flex align-items-center">
                      <label htmlFor="">Status</label>
                      <select
                        name="status"
                        id=""
                        value={credentials.status}
                        onChange={handleInput}
                      >
                        <option value="all">Choose status</option>
                        <option value="new">New</option>
                        <option value="cancelled">Cancelled</option>
                        <option value="completed">Completed</option>
                      </select>
                    </div>
                    <Link
                      to=""
                      onClick={handleResetBtn}
                      className="btn btn-prim w-auto"
                    >
                      RESET
                    </Link>
                  </div>
                </div>
              </motion.div>
            </>
          )}
        </div>
        {/* row */}
        <div className="table-wrap">
          <div className="row">
            <div className="col-12">
              <div className={styles.card_box}>
                <div className={styles.tables_wrap}>
                  <div className="table-responsive">
                    <table className="table align-middle">
                      <thead>
                        <tr>
                          <th>ORDER#</th>
                          <th>PICKUP CODE</th>
                          <th>LOCKER</th>
                          <th>BOOKED BY</th>
                          <th>CUSTOMER</th>
                          <th>ORDER DATE</th>
                          <th>STATUS</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading && (
                          <>
                            <tr>
                              <td
                                colSpan={6}
                                className="text-center"
                                style={{ background: "transparent" }}
                              >
                                <HashLoader
                                  color={`#0b0d41`}
                                  loading={isLoading}
                                  size={40}
                                  aria-label="Loading Spinner"
                                  data-testid="loader"
                                />
                              </td>
                            </tr>
                          </>
                        )}
                        {isDisplay &&
                          data.map((item, i) => (
                            <motion.tr
                              key={item._id}
                              initial={{ opacity: 0 }}
                              animate={{ opacity: 1 }}
                              transition={{ duration: 1.2, delay: i * 0.1 }}
                            >
                              <td>{item.order_number}</td>
                              <td>{item.pickup_code}</td>
                              <td> {item.locker_number}</td>
                              <td>
                                <h6
                                  className="mb-0 m-0 fs-15 "
                                  style={{
                                    fontSize: "11px",
                                    // fontWeight: "200",
                                  }}
                                >
                                  {item.user.name}
                                  <br />
                                  {/* {item.user.email} */}
                                </h6>
                              </td>
                              <td>
                                <h6
                                  className="mb-0 m-0 fs-15 "
                                  style={{
                                    fontSize: "11px",
                                    // fontWeight: "200",
                                  }}
                                >
                                  {item.customer && item.customer !== "" && (
                                    <div>
                                      {item.customer.name} <br />
                                    </div>
                                  )}
                                  {item.customer_email}
                                </h6>
                              </td>
                              <td
                                style={{
                                  fontSize: "11px",
                                  // fontWeight: "200",
                                }}
                              >
                                {formattedDate(item.createdAt)}
                              </td>
                              <td>
                                {item.status === "new" && (
                                  <span
                                    className="badge bg-primary"
                                    style={{ fontSize: "11px" }}
                                  >
                                    New
                                  </span>
                                )}
                                {item.status === "completed" && (
                                  <>
                                    <span
                                      className="badge bg-success"
                                      style={{ fontSize: "11px" }}
                                    >
                                      Completed
                                    </span>
                                    <br />
                                    <span style={{ fontSize: "11px" }}>
                                      Pickup time:{" "}
                                      {formattedDate(item.updatedAt)}
                                    </span>
                                  </>
                                )}
                                {item.status === "cancelled" && (
                                  <span
                                    className="badge bg-danger"
                                    style={{ fontSize: "11px" }}
                                  >
                                    Cancelled
                                  </span>
                                )}
                                {item.status === "refunded" && (
                                  <span
                                    className="badge bg-danger"
                                    style={{ fontSize: "11px" }}
                                  >
                                    Refunded
                                  </span>
                                )}
                                {item.status === "occupied" && (
                                  <span
                                    className="badge bg-warning"
                                    style={{ fontSize: "11px" }}
                                  >
                                    Occupied
                                  </span>
                                )}
                              </td>
                              <td className="d-flex gap-1 text-end">
                                {/* {item.status === "new" &&
                                  item?.has_door === "yes" && (
                                    <button
                                      type="button"
                                      className="btn btn-warning text-white btn-sm"
                                      onClick={() => {
                                        HandleOpenLocker(
                                          item.locker_id,
                                          item.relay
                                        );
                                      }}
                                      disabled={
                                        doorLoadingStates[item.locker_id]
                                      }
                                    >
                                      {doorLoadingStates[item.locker_id]
                                        ? "opening..."
                                        : "OpenDoor"}
                                    </button>
                                  )} */}
                                {item.status === "new" && (
                                  <Link
                                    onClick={() => {
                                      HandleOpenLocker(
                                        item.locker_id,
                                        item.relay
                                      );
                                    }}
                                    disabled={itemLoadingStates[item.locker_id]}
                                  >
                                    <>
                                      {itemLoadingStates[item.locker_id] ? (
                                        <div
                                          className="spinner-grow text-primary"
                                          role="status"
                                        >
                                          <span className="visually-hidden">
                                            Loading...
                                          </span>
                                        </div>
                                      ) : (
                                        <Tooltip title="Open Locker">
                                          <img
                                            src={LockerIcon}
                                            alt="open locker"
                                          />
                                        </Tooltip>
                                      )}
                                    </>
                                  </Link>
                                )}

                                {item.status === "new" && item.customer_email && (
                                  <Link onClick={() => openResendModal(item)}>
                                    <Tooltip title="Resend Email">
                                      <img
                                        src={ResendEmailIcon}
                                        alt="resend email"
                                      />
                                    </Tooltip>
                                  </Link>
                                )}

                                <Link to={`/pickup/detail/${item._id} `}>
                                  <Tooltip title="Detail">
                                    <img src={InfoIcon} alt="detail" />
                                  </Tooltip>
                                </Link>
                                {item.status === "new" && (
                                  <Link to={`/pickup/edit/${item._id}`}>
                                    <Tooltip title="Edit">
                                      <img src={EditIcon} alt="edit" />
                                    </Tooltip>
                                  </Link>
                                )}
                                <Link onClick={() => handleDelete(item._id)}>
                                  <Tooltip title="Delete">
                                    <img src={DeleteIcon} alt="delete" />
                                  </Tooltip>
                                </Link>
                              </td>
                            </motion.tr>
                          ))}
                        {isNotFound && (
                          <tr>
                            <td colSpan={7} className="text-center">
                              No Data Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="table-num">
                    {data.length > 0 && (
                      <ReactPaginate
                        previousLabel={"<"}
                        nextLabel={">"}
                        breakLabel={"..."}
                        pageCount={totalPages}
                        forcePage={currentPage - 1} // react-paginate uses zero-based indexing
                        onPageChange={handlePageChange}
                        containerClassName={" dig-num"}
                        pageClassName={"dig-num"}
                        previousClassName={"num-btns"}
                        nextClassName={"num-btns"}
                        disabledClassName={"pagination-disabled"}
                        activeClassName={"pagination-active"}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        title="Resend pickup email?"
        open={resendModalOpen}
        onCancel={closeResendModal}
        onOk={handleResendEmail}
        okText="Send Email"
        cancelText="Cancel"
        confirmLoading={resendLoading}
        cancelButtonProps={{ disabled: resendLoading }}
        centered
      >
        <p style={{ marginBottom: 8 }}>
          The same new pickup email sent when this order was booked will be
          resent to:
        </p>
        <Input
          type="email"
          value={resendEmail}
          onChange={(e) => setResendEmail(e.target.value)}
          placeholder="Customer email address"
          autoFocus
        />
      </Modal>
    </div>
  );
};
export default Pickups;
